module.exports = __webpack_public_path__ + "static/media/icone-crescimento.b0f28906.png";